/* MARIE SOPHIE — Warenkorb-Steuerung und Warenkorb-Pop-up.
   1. Ein Warenkorb: bringt eine App einen eigenen Drawer mit, wird stattdessen
      der Drawer des Shops geöffnet (umschaltbar).
   2. Der Warenkorb geht sofort auf, der Inhalt lädt im Hintergrund nach.
   3. Mengenänderungen auf der Warenkorbseite werden sofort angezeigt.
   4. Pop-up: zeigt den ersten Mantel, der noch nicht im Warenkorb liegt. */
(function(){
  var cfg = document.querySelector('[data-ms-cart]');
  if(!cfg || window.__msCartInit) return;
  window.__msCartInit = true;

  var OWN   = cfg.dataset.own === 'true';
  var WAIT  = parseInt(cfg.dataset.delay || '700', 10);
  var ONCE  = cfg.dataset.freq !== 'always';
  var KEY   = 'ms_cup_done';
  var ONCART = document.body.classList.contains('template-cart');

  var box   = document.querySelector('[data-cup]');
  var items = box ? [].slice.call(box.querySelectorAll('[data-cup-item]')) : [];
  var addB  = box ? box.querySelector('[data-cup-add]') : null;
  var timer = null, open = false;

  function sternify(){
    return window.SternifyCart && window.SternifyCart.open ? window.SternifyCart : null;
  }
  if(OWN) document.body.classList.add('ms-owncart');

  function sectionUrl(name){
    return location.pathname + (location.search ? location.search + '&' : '?') + 'sections=' + name;
  }

  /* ---------- eigener Drawer ---------- */
  function openOwn(){
    var d = document.querySelector('[data-drawer]');
    var s = document.querySelector('[data-scrim]');
    if(!d) return;
    d.classList.add('is-on');
    if(s) s.classList.add('is-on');
    document.body.classList.add('is-locked');
    d.setAttribute('aria-hidden', 'false');
  }
  function refreshDrawer(){
    return fetch(sectionUrl('cart-drawer'))
      .then(function(r){ return r.json(); })
      .then(function(j){
        var host = document.querySelector('[data-drawer-host]');
        if(!host || !j['cart-drawer']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = j['cart-drawer'];
        var fresh = tmp.querySelector('[data-drawer-host]');
        if(fresh) host.innerHTML = fresh.innerHTML;
        var n = host.querySelector('[data-count-src]');
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = n ? n.dataset.countSrc : '0';
        });
      })
      .catch(function(){});
  }

  if(OWN){
    document.addEventListener('click', function(e){
      if(e.target.closest && e.target.closest('[data-cart-open]')) openOwn();
    }, true);
  }

  /* ---------- Warenkorbseite aktuell halten ---------- */
  function refreshCartPage(){
    return fetch(sectionUrl('main-cart'))
      .then(function(r){ return r.json(); })
      .then(function(j){
        var html = j['main-cart'];
        if(!html) return;
        var el = document.querySelector('.wrap--narrow');
        var host = el ? el.closest('[id^="shopify-section"]') : null;
        if(!host) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[id^="shopify-section"]') || tmp;
        host.innerHTML = fresh.innerHTML;
      })
      .catch(function(){});
  }

  if(ONCART){
    document.addEventListener('click', function(e){
      var q = e.target.closest ? e.target.closest('[data-qty]') : null;
      if(!q) return;
      e.preventDefault();
      e.stopPropagation();
      var line = parseInt(q.dataset.line, 10);
      var qty  = Math.max(0, parseInt(q.dataset.qtyVal, 10));
      q.disabled = true;
      fetch('/cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function(){
          var sc = sternify();
          if(sc && sc.loadCart){ try{ sc.loadCart(); }catch(err){} }
          return Promise.all([ refreshCartPage(), refreshDrawer() ]);
        })
        .catch(function(){ q.disabled = false; });
    }, true);
  }

  /* ---------- Pop-up ---------- */
  function done(){ if(!ONCE) return; try{ sessionStorage.setItem(KEY,'1'); }catch(e){} }
  function isDone(){ if(!ONCE) return false; try{ return sessionStorage.getItem(KEY) === '1'; }catch(e){ return false; } }

  function activeItem(){
    for(var i=0;i<items.length;i++){ if(!items[i].hidden) return items[i]; }
    return null;
  }
  function show(item){
    if(open || !box || !item) return;
    items.forEach(function(el){ el.hidden = el !== item; });
    open = true;
    box.hidden = false;
    requestAnimationFrame(function(){ box.classList.add('is-on'); });
  }
  function hide(){
    if(!box) return;
    open = false;
    box.classList.remove('is-on');
    setTimeout(function(){ if(!open) box.hidden = true; }, 340);
  }
  function schedule(){
    if(!box) return;
    clearTimeout(timer);
    timer = setTimeout(maybeShow, WAIT);
  }
  function maybeShow(){
    if(!box || !items.length || isDone() || open) return;
    fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if(!c || !c.item_count) return;
        var inCart = {};
        c.items.forEach(function(i){ inCart[i.product_id] = true; });
        for(var i=0;i<items.length;i++){
          if(!inCart[parseInt(items[i].dataset.pid, 10)]){ show(items[i]); return; }
        }
      })
      .catch(function(){});
  }

  if(box){
    box.addEventListener('change', function(e){
      var sel = e.target.closest ? e.target.closest('[data-cup-variant]') : null;
      if(!sel || sel.tagName !== 'SELECT') return;
      var o = sel.options[sel.selectedIndex];
      var item = sel.closest('[data-cup-item]');
      if(!o || !item) return;
      var pEl = item.querySelector('[data-cup-price]');
      var wEl = item.querySelector('[data-cup-was]');
      if(pEl && o.dataset.price) pEl.textContent = o.dataset.price;
      if(wEl){
        if(o.dataset.was){ wEl.textContent = o.dataset.was; wEl.hidden = false; }
        else { wEl.textContent = ''; wEl.hidden = true; }
      }
    });

    box.addEventListener('click', function(e){
      if(e.target.closest('[data-cup-close]')){ done(); hide(); }
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && open){ done(); hide(); }
    });

    if(addB){
      addB.addEventListener('click', function(){
        var item = activeItem();
        var sel = item ? item.querySelector('[data-cup-variant]') : null;
        if(!sel || !sel.value) return;
        var label = addB.textContent;
        addB.disabled = true;
        addB.textContent = 'Wird hinzugefügt …';
        fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ items:[{ id: sel.value, quantity: 1 }] })
        })
          .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
          .then(function(){
            var sc = sternify();
            if(sc && sc.loadCart){ try{ sc.loadCart(); }catch(e){} }
            return ONCART ? Promise.all([ refreshCartPage(), refreshDrawer() ]) : refreshDrawer();
          })
          .then(function(){
            done();
            addB.textContent = label;
            addB.disabled = false;
            hide();
          })
          .catch(function(){
            addB.textContent = 'Nicht hinzugefügt — bitte erneut versuchen';
            setTimeout(function(){ addB.textContent = label; addB.disabled = false; }, 2600);
          });
      });
    }
  }

  /* ---------- Warenkorb beobachten ---------- */
  function isOpen(el){
    return el.classList.contains('is-on') || el.classList.contains('sd-drawer--open');
  }
  function watch(el){
    if(!el || el.__msWatched || !('MutationObserver' in window)) return;
    el.__msWatched = true;
    var isApp = el.classList.contains('sd-drawer');
    new MutationObserver(function(){
      var sc = sternify();
      var on = isOpen(el);

      if(isApp && OWN){
        if(on){
          if(sc && sc.close){ try{ sc.close(); }catch(e){} }
          openOwn();
          refreshDrawer();
          schedule();
        }
        return;
      }

      if(on){
        if(isApp && sc && sc.loadCart){ try{ sc.loadCart(); }catch(e){} }
        if(!isApp && !OWN && sc){
          try{ sc.loadCart(); sc.open(); }catch(e){}
          return;
        }
        schedule();
      } else {
        clearTimeout(timer);
        if(open){ done(); hide(); }
      }
    }).observe(el, { attributes:true, attributeFilter:['class'] });
  }
  function scan(){
    watch(document.querySelector('[data-drawer]'));
    watch(document.querySelector('.sd-drawer'));
  }
  scan();
  var tries = 0;
  var iv = setInterval(function(){ scan(); if(++tries > 40) clearInterval(iv); }, 500);

  if(ONCART) setTimeout(maybeShow, WAIT);
})();
